import { createContext, useReducer } from "react";
import React from "react";
import { VIEW_TYPES } from "../functions/postActionTypes";

export const BadgeContext = createContext<any>({});

export const BadgeContextProvider: React.FC<any> = ({ children }) => {
    
    // The Badge System: Purpose - Lead the users to their required actions
    
    // The Badge System: Process - All the Level 3 Badge Counts are counted at their respective 
    // context. Then they are set (thru badgeDispatch) and processed (thru the badgeCountUpdates 
    // function) and the BadgeContext feeds the counts throughout the app. 

    // Badge counts need to be available at the most granular level to support the specific action
    //  the user needs to take. These are then aggregated at the higher levels to summarize the 
    //  activity in a particular section of the app.

    // 1) TOP LEVEL - Summary badge counts are displayed on the Tab Navigator, this guides the user
    //     to the tab / page they should be looking at.
    // 2) MIDDLE LEVEL - Catagorized badge counts are displayed in the segment selector (where 
    //     applicable)
    // 3) BOTTOM LEVEL - Each item that has been counted (above) is displayed on the page with a
    //     red-eye or other indicator 
    
    const [jobCardSearchText, setJobCardSearchText] = React.useState("");
    const [associatesSearchText, setAssociatesSearchText] = React.useState("");

    const INITIAL_STATE = {
        docStamp: "grease...",
    };

    
    // Need to setup this up to refresh the device's home screen badge count
    // Commented out for future use
    const badgeCountReducer = (state: any, action: { type: any; payload: any; }) => {

        switch (action.type) {
            case VIEW_TYPES.JOB_CARD_SEARCH_TEXT:
                setJobCardSearchText(action.payload);
                return {};
            case VIEW_TYPES.ASSOCIATES_SEARCH_TEXT:
                // console.log("associates search text", action.payload);
                setAssociatesSearchText(action.payload);
                return {};
            default:
                return state;
        }
    };
    const [, badgeDispatch] = useReducer(badgeCountReducer, INITIAL_STATE);

    return (
    <BadgeContext.Provider value={{ 
        jobCardSearchText, 
        associatesSearchText,
        badgeDispatch, 
    }}>
        {children}
    </BadgeContext.Provider>
    );
};